import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import EditLessonDetails from './EditLessonDetails';
import EditLessonMaterial from './EditLessonMaterial';
import { Lesson } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Training/Courses/Lessons/PathItems';
import { Course, Module } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Training/Courses/PathItems';
import { OperationRequest } from '@peercolab/engine';

interface EditLessonProps {
  course: Course
  module: Module
  lesson: Lesson;
  patchField: <R, V>(operation: OperationRequest<unknown, R>, newValue: V, currentValue: V, revertHandler: (value: V) => void) => Promise<void>;
  onBack: () => void;
}

const EditLesson: React.FC<EditLessonProps> = ({ course, module, lesson, onBack, patchField }) => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ flex: 1 }}>
          <Tab label="Details" />
          <Tab label="Material" />
        </Tabs>
      </Box>
      {tab === 0 && (
        <EditLessonDetails course={course} module={module} lesson={lesson} patchField={patchField} />
      )}
      {tab === 1 && (
        <EditLessonMaterial course={course} module={module} lesson={lesson} patchField={patchField} />
      )}
    </Box>
  );
};

export default EditLesson;
